import type { PackagingItemAuditStatus } from '@/shared/hooks/api/packagingItemsOverview'
import type { PackedItemsOverviewPackagingItem } from '@/shared/hooks/api/packedItemsOverview'

export const PACKAGING_ITEM_AUDIT_STATUS_VALUES = [
  'not_audited',
  'clear',
  'flagged',
] as const satisfies readonly PackagingItemAuditStatus[]

export function packagingItemAuditStatusLabelKey(
  status: PackagingItemAuditStatus
): `list.audit.status.${PackagingItemAuditStatus}` {
  return `list.audit.status.${status}`
}

export function deriveLatestPackagingItemAuditRunAt(
  packagingItems: Array<{ auditLastRunAt?: string | null }>
): string | null {
  let latest: string | null = null
  for (const item of packagingItems) {
    const runAt = item.auditLastRunAt
    if (runAt == null || runAt === '') {
      continue
    }
    if (latest == null || runAt > latest) {
      latest = runAt
    }
  }
  return latest
}

export function derivePackedItemAuditStates(
  packagingItems: PackedItemsOverviewPackagingItem[]
): PackagingItemAuditStatus[] {
  const states = new Set<PackagingItemAuditStatus>()
  for (const item of packagingItems) {
    states.add(item.auditStatus)
  }
  return PACKAGING_ITEM_AUDIT_STATUS_VALUES.filter((state) => states.has(state))
}
